<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="用户ID" prop="userId">
                <el-input v-model="query.userId" placeholder="请输入用户ID" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="手机号" prop="userMobile">
                <el-input v-model="query.userMobile" placeholder="请输入手机号" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="日期" prop="date">
                <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
        <!-- <template slot="btns" v-if="permission('/device/util/add')">
            <el-button size="mini" type="primary" @click="handleAdd">
                新增配件
            </el-button>
        </template> -->
        <template slot="tabs">
            <el-tabs v-model="activeName">
                <el-tab-pane label="待审核" name="first"></el-tab-pane>
                <el-tab-pane label="已拒绝" name="second"></el-tab-pane>
                <el-tab-pane label="已激活" name="third"></el-tab-pane>
            </el-tabs>
        </template>
        <template slot="columns">
            <el-table-column label="序号" align="center" type="index" width="100"></el-table-column>
            <el-table-column label="提交人ID" align="center" prop="userId"></el-table-column>
            <el-table-column label="提交时间" align="center" prop="createTime"></el-table-column>
            <el-table-column label="产品名称" align="center" prop="deviceName"></el-table-column>
            <el-table-column label="产品SN码" align="center" prop="deviceSn"></el-table-column>
            <el-table-column label="购买日期" align="center" prop="buyTime"></el-table-column>
            <el-table-column label="审核时间" align="center" prop="auditTime"></el-table-column>
            <el-table-column label="操作" align="center" width="140" v-if="permission('/device/util/delete')">
                <template slot-scope="{ row }">
                    <el-link style="margin-left: 10px;" :underline="false" type="danger" @click="handleDel(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page } from "@/api/device/list";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                userId: "",
                userMobile: "",
                date: [],
                category: '配件'
            },
            activeName: 'first',
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            const num = /^[\d]*$/;
            if (!num.test(this.query.userId)) {
                this.$message.error('用户ID格式不正确')
                return;
            }
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date && this.query.date[0] ? this.query.date[0] + " 00:00:00" : "",
                endTime: this.query.date && this.query.date[1] ? this.query.date[1] + " 23:59:59" : ""
            };
            delete params.date;
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleDetail(row) {
            this.$router.push({ path: "/user/detail", query: { id: row.id } });
        },
        handleAdd() {
            // this.$router.push({ path: "/user/feedback" });
        }
    },
};
</script>